var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"template-confirmation-view"}},[_c('BookingSummary',{attrs:{"title":"You're Going to Orlando!","step":"confirmation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }